<span class="combo-bet-linear__edit-toggle-container">
    <span class="combo-bet-linear__edit-toggle" (click)="toggleExpand($event)">{{ toggleText }} {{ pickSelectionText }}</span>
    <span
        class="combo-bet-linear__edit-toggle-icon"
        [ngClass]="{
            'theme-up': expanded,
            'theme-down': !expanded,
        }"
        (click)="toggleExpand($event)">
    </span>
</span>
